import React from 'react';

interface Props {
  size?: number;
  showText?: boolean;
  className?: string;
  glow?: boolean;
}

/** The Nexus "N" mark — pure SVG so it inherits the accent color and
 * the neon glow from the CSS theme. Used in the auth splash, the top
 * nav, and the empty-workspace hero.
 */
export const NexusLogo: React.FC<Props> = ({ size = 40, showText = false, className = '', glow = true }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="nexus-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={glow ? 'nx-logo-halo' : ''}
      >
        <path
          d="M12 40V8h4l16 24V8h4v32h-4L16 16v24h-4Z"
          fill="hsl(var(--accent))"
        />
      </svg>
      {showText && (
        <span
          className="tracking-[0.3em] font-light text-lg"
          style={{ color: 'hsl(var(--text))' }}
        >
          NEXUS
        </span>
      )}
    </div>
  );
};

export default NexusLogo;
